import { axiosInstance } from '../../axios-config';
// import qs from 'qs';
import { get } from 'lodash';
import * as auth from '../../helpers/auth';
import * as systemConstants from '../../constants/systemConstants';

class Auth {
  // eslint-disable-next-line lines-around-comment
  /**
   * auth2 login api
   * @param {string} url String
   * @param {object} payload Object
   * @param {object} action Object e.g {type: 'AUTH', dispatch: function(){} }
   * @returns {Promise<void>} void
   */

  static async login(url, payload, action) {
    const { dispatch } = action;
    try {
      const fullUrl = systemConstants.API_URL + url;
      const response = await axiosInstance.post(fullUrl, payload);
      if (response.data.code === systemConstants.API_SUCCESS) {
        auth.login(response.data);
        if (payload.remember) {
          auth.setRemember(response.data.user);
        }
        else {
          auth.removeRemember();
        }
        dispatch({ type: systemConstants.LOGIN_SUCCESS, payload: response.data });
        return;
      }
      dispatch({ type: systemConstants.LOGIN_FAILURE, payload: response.data.message });
      return;
    }
    catch (err) {
      let data = get(err, 'response.data', null);
      data = !!data ? data : get(err, 'response');
      data = !!data ? data : err;
      dispatch({ type: systemConstants.LOGIN_FAILURE, payload: data });
    }
  }

  static get(url, payload) {
    const fullUrl = systemConstants.API_URL + url;
    return axiosInstance.get(fullUrl, payload);
  }

  static post(url, payload) {
    const fullUrl = systemConstants.API_URL + url;
    return axiosInstance.post(fullUrl, payload);
  }
}
export default Auth;
